import "./Form.css";
import { useRef, useState } from "react";
import IntroductionCard from "../Card/IntroductionCard";
import GatherDataCard from "../Card/GatherDataCard";

import { Helmet } from "react-helmet-async";

function Form() {
  const [introduction, setIntroduction] = useState(true);

  const formRef = useRef<HTMLDivElement>(null);

  function start(): void {
    if (formRef.current) {
      formRef.current.style.backgroundPositionY = "12.5%";
      formRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      setIntroduction(!introduction);
    }
  }

  function restart(): void {
    if (formRef.current) {
      formRef.current.style.backgroundPositionY = "0%";
      document
        .getElementsByClassName("header")[0]
        .scrollIntoView({ behavior: "smooth", block: "start" });
      setIntroduction(!introduction);
    }
  }

  return (
    <div id="form" ref={formRef} className="form-div df fdc aic jcc">
      <Helmet>
        <title>GSPEN – კალორიული კალკულატორი & კვების გეგმა</title>
        <meta
          name="description"
          content="კალორიული გეგმა გვიჩვენებს თუ რა ტიპის და რა რაოდენობის საკვები უნდა მივირთვათ დღის განმავლობაში, ჩვენს ფიზიკურ მონაცემებზე დაყრდნობით."
        />
        <link rel="canonical" href="https://www.gspen.ge" />
      </Helmet>

      {introduction ? (
        <IntroductionCard changeState={start} />
      ) : (
        <GatherDataCard changeState={restart} />
      )}
    </div>
  );
}

export default Form;
